export const LAC1_DID_TYPE_CODE = "0001";
export const LAC1_DID_METHOD_NAME = "lac1";
